<script setup lang="ts">
import {Toaster} from '@/components/ui/sonner';
</script>

<template>
  <RouterView />
  <!--
    Top right, not the library's bottom right: an action is taken at the top of a page —
    the header's buttons, a dialog's footer — and a message about it that appears at the
    bottom of a long page is a message nobody sees.
  -->
  <Toaster position="top-right" rich-colors close-button />
</template>
